import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { COMPANY_DATA_AREA_IDS } from "../declarations/ODataExplorer";
import React from "react";

interface ICompanyPickerProps {
    onChange: (companies: string[]) => void;
    value: string[];
}

export default function CompanyPicker({ onChange, value }: ICompanyPickerProps) {
    return (
        <Autocomplete
            multiple
            onChange={(_, v) => onChange(v)}
            options={[...COMPANY_DATA_AREA_IDS]}
            renderInput={(params) => (
                <TextField {...params} label="Companies" placeholder={value.length === 0 ? "All companies" : ""} />
            )}
            sx={{ minWidth: 320 }}
            value={value}
            size="small"
        />
    );
}
